import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'urlCombining'
})
export class UrlCombiningPipe implements PipeTransform {
    transform(domainUrl: string, combineableUrl: null | string) {
        const domain = new URL(domainUrl).origin;
        if (!combineableUrl) {
            return domain;
        }

        if (URL.canParse(combineableUrl)) {
            const pathname = new URL(combineableUrl).pathname;
            return `${domain}${pathname}`;
        } else {
            const pathname = combineableUrl.startsWith('/') ? combineableUrl : `/${combineableUrl}`;
            return `${domain}${pathname}`;
        }
    }
}
